import type { FirebaseOptions } from 'firebase/app'

/** The `runtimeConfig.public` keys the browser's FirebaseApp is built from. */
export interface FirebaseClientPublicConfig {
  firebaseApiKey?: string
  firebaseAuthDomain?: string
  firebaseProjectId?: string
  firebaseAppId?: string
}

/**
 * The options `app/plugins/firebase.client.ts` passes to `initializeApp`.
 *
 * `appId` is not optional for us even though Auth works without it: App Check exchanges its
 * reCAPTCHA attestation at `/apps/{appId}:exchangeRecaptchaEnterpriseToken`, and without one that
 * is `/apps/undefined:`, which fails, so the browser sends no token and the server refuses every new
 * account its first `users` row (MAR-1214 F1). `server/plugins/appCheckReadiness.ts` refuses to
 * start a production server whose config lacks it.
 */
export function firebaseClientOptions(config: FirebaseClientPublicConfig): FirebaseOptions {
  const appId = config.firebaseAppId?.trim()
  return {
    apiKey: config.firebaseApiKey,
    authDomain: config.firebaseAuthDomain,
    // `projectId`, not `clientId` — Auth infers its project from authDomain, but
    // Firestore reads projectId off the app and throws "projectId not provided in
    // firebase.initializeApp" without it (hit on /research, which subscribes to the
    // public_rag_jobs queue).
    projectId: config.firebaseProjectId,
    ...(appId ? { appId } : {}),
  }
}
